import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";
import { PaymentUploadedTransactions } from "../../../../components/DirectDeposit/Transactions/PaymentUploaded";

export interface IPaymentUploadedTransactionsPage { }

export const PaymentUploadedTransactionsPage: FC<IPaymentUploadedTransactionsPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Payment Uploaded"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<PaymentUploadedTransactions />}
		/>
	);
};
